import api from "../apiClient";

const performanceService = {
  // Performance Cycles
  getCycles: async () => {
    try {
      const response = await api.get("/performance/cycles");
      // The API returns { responseCode, responseMessage, data }
      // We need to return the full response structure
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  createCycle: async (cycleData) => {
    try {
      
      const response = await api.post("/performance/cycles", cycleData);
      
      // Return the full response structure
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  updateCycle: async (cycleId, cycleData) => {
    try {
      
      const response = await api.put(
        `/performance/cycles/${cycleId}`,
        cycleData
      );
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  deleteCycle: async (cycleId) => {
    try {
      
      const response = await api.delete(`/performance/cycles/${cycleId}`);
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Update cycle statistics
  updateCycleStats: async (cycleId, statsData) => {
    try {
      
      
      
      
      
      const response = await api.put(
        `/performance/cycles/${cycleId}/stats`,
        statsData
      );
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Get cycle details
  getCycleById: async (cycleId) => {
    try {
      
      const response = await api.get(`/performance/cycles/${cycleId}`);
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Update cycle stages
  updateCycleStages: async (cycleId, stagesData) => {
    try {
      
      
      
      
      
      const response = await api.put(
        `/performance/cycles/${cycleId}/stages`,
        stagesData
      );
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Mark stage as completed
  completeStage: async (cycleId, stageIndex) => {
    try {
      
      const response = await api.put(
        `/performance/cycles/${cycleId}/stages/${stageIndex}/complete`
      );
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Performance Goals
  getGoals: async (filters = {}) => {
    try {
      const response = await api.get("/performance/goals", { params: filters });
      return response; // apiClient already returns response.data
    } catch (error) {
      
      throw error;
    }
  },

  createGoal: async (goalData) => {
    try {
      const response = await api.post("/performance/goals", goalData);
      return response; // Return full response
    } catch (error) {
      
      throw error;
    }
  },

  updateGoal: async (goalId, goalData) => {
    try {
      const response = await api.put(`/performance/goals/${goalId}`, goalData);
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  deleteGoal: async (goalId) => {
    try {
      const response = await api.delete(`/performance/goals/${goalId}`);
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  // Performance Reviews
  getReviews: async (filters = {}) => {
    try {
      
      
      
      
      const response = await api.get("/performance/reviews", {
        params: filters,
      });
      
      return response; // Return full response structure
    } catch (error) {
      
      throw error;
    }
  },

  getReviewById: async (reviewId) => {
    try {
      
      const response = await api.get(`/performance/reviews/${reviewId}`);
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  createReview: async (reviewData) => {
    try {
      
      const response = await api.post("/performance/reviews", reviewData);
      
      return response; // Return full response structure
    } catch (error) {
      
      throw error;
    }
  },

  updateReview: async (reviewId, reviewData) => {
    try {
      
      const response = await api.put(
        `/performance/reviews/${reviewId}`,
        reviewData
      );
      
      return response; // Return full response structure
    } catch (error) {
      
      throw error;
    }
  },

  deleteReview: async (reviewId) => {
    try {
      
      const response = await api.delete(`/performance/reviews/${reviewId}`);
      
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  // Performance Calibration
  getCalibration: async () => {
    try {
      const response = await api.get("/performance/calibration");
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  saveCalibration: async (calibrationData) => {
    try {
      const response = await api.post(
        "/performance/calibration",
        calibrationData
      );
      return response.data;
    } catch (error) {
      
      throw error;
    }
  },

  exportPerformanceCycle: async (cycleId, fallbackName = 'PerformanceCycle') => {
    try {
      if (!cycleId) {
        return { success: false, error: 'Cycle ID is required' };
      }

      const blob = await api.get(`/performance/cycles/${cycleId}/export`, { responseType: 'blob' });

      const sanitized = String(fallbackName || 'PerformanceCycle')
        .replace(/[\\/:*?"<>|]/g, '')
        .replace(/\s+/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_+|_+$/g, '')
        .slice(0, 80) || 'PerformanceCycle';
      const filename = `PerformanceCycle_${sanitized}.xlsx`;

      const objectUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(objectUrl);

      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to export performance cycle details'
      };
    }
  },
};

export default performanceService;
